export const ADMIN = 'bwycstand'
export const BACKEND = 'backend'
export const STANDARD = 'bwycstand'
export const BMWSTANDARD = 'bwycstand'
export const HOTKEY = 'bmwfhotkey'
export const USER = 'user'

export const ROLE_OPTIONS = []